module.exports = "https://www.gc-qa.gnp.com.mx/ab1cd6e5832b4952099c63eb06a23d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/reembolso-gmm/01.png
// module id = 1047
// module chunks = 0 1